import {LitElement, html, CSSResult, unsafeCSS} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import styles from './step-two.scss';
import {consume} from "@lit/context";
import {i18nContext} from "./i18nContext.js";
import {Messages} from "../../@types/online-reservation.js";
import arrowBackIcon
  from '@breuni-ui/nui/dist/design-tokens/images/icons/nui-arrow_left_direction=left_size=16_weight=regular.svg';

@customElement('step-two')
export class StepTwo extends LitElement {

  @property({ type: Function }) onNext!: () => void;

  @property({ type: Function }) onPrev!: () => void;

  @property({ type: Function }) selectSize!: (size: string) => void;

  @property({type: Object, reflect: false})
  private sizesWithStoreStock: string[];

  @consume({context: i18nContext})
  private messages!: Messages;

  static get styles(): CSSResult {
    return unsafeCSS(styles);
  }

  render() {
    return html`
      <div role="button">
          <span
            class="ents-copy ents-or__back--button"
            data-test-ents-or-step2-back-button
            aria-label="${this.messages['back']}"
            @click="${() => this.onPrev()}"
          >${this.addPresentationToIcon(arrowBackIcon())} ${this.messages['back']}</span>
      </div>
      <div class="ents-or__sizeselect-section">
        <h2 class="ents-or__reservation-header ents-heading-medium" data-test-ents-or-steptwo-header>${this.messages['stepTwoHeader']}</h2>
        <div class="ents-or__sizelist">
            ${this.sizesWithStoreStock.map(size => this.renderItem(size))}
        </div>
      </div>
    `;
  }

  private addPresentationToIcon(icon: SVGElement){
    icon.setAttribute('role', 'presentation');
    return icon;
  }

  private renderItem(size: string) {
    return html`
      <label class="ents-copy-small-bold ents-or__item" data-test-ents-or-size-item>
        <input type="checkbox" name="ents-size-selector"
               @click="${this.selectItem(size)}"
               @keydown.enter="${this.selectItem(size)}"
               value="${size}"
        />
        <div class="ents-or__size">
          <div class="ents-or__size-information" data-test-ents-or-size-item-text>
            <span>${size}</span>
          </div>
        </div>
      </label>
    `;
  }

  private selectItem(size: string) {
    return () => {
      this.selectSize(size); // Call the selectSize method passed as a property
      this.onNext(); // Proceed to the next step
    };
  }
}
